module.exports = __webpack_public_path__ + "media/images/athletes/995-11cae78036af82e6923e1e3c5bcc605a.png";